export const iconFontAwesomeCampingCompass = (
	<i className="fa-solid fa-compass"></i>
);
